module.exports = __webpack_public_path__ + "fonts/NimbusMonoL-Bold.b49e38ad.eot";